<template>
  <div class="item-sequence" v-if="!hide_item">
    <el-card
      v-if="suggestion"
      class="dayplanner-suggestion-card"
      :body-style="{ padding: '0.5em' }">
      <div class="dayplanner-suggestion-item" >
        <div class="w-100">
          <div style="display: flex">
            <div class="dayplanner-suggestion-item-image"
              :style="imageStyle"
              @click="onGoToCommitment()"
              style="cursor: pointer">
              <div style="width: 48px; height: 48px"></div>
            </div>
            <div>
              <div class="small-caps-goal-title"
                @click="onGoToCommitment()"
                style="cursor: pointer">
                {{goal_meta.name}}
              </div>
              <div
                class="sessions-effort-text"
                style="cursor: pointer; width: 190px"
                @click="onGoToCommitment()">
                {{ name }} - day {{ suggestion.day }}
                <span v-if="suggestion.daysTotal">/ {{ suggestion.daysTotal }}</span>
              </div>
              <!--<el-popover
                placement="top"
                width="190"
                trigger="hover">
                <div class="dayplanner-suggestion-item-text" style="font-size: 11pt; word-break: break-word;">
                  You have planned
                  {{ sessionPlacementDuration | hoursMinutes }}
                  of your
                  <span style="text-decoration: underline">{{ sessionPlacementDuration | hoursMinutes }}</span> daily goal
                </div>
                <div style="width: 185px" slot="reference">
                  <el-progress
                    v-if="progress_status && progress_status !== ''"
                    :percentage="progress_percentage"
                    :status="progress_status" />
                  <el-progress v-else :percentage="progress_percentage"></el-progress>
                </div>
              </el-popover>-->
            </div>
          </div>
          <div
            style="padding-top: 0.3em;"
            class="w-100">
            <div
              v-for="(task, idx) in suggestion.tasks"
              :key="'suggestions-' + config.commitmentId + idx"
              class="dayplanner-item-sequence-task">
              <div
                v-if="!sequenceItemIdAdded(task.sequenceItemId)"
                :style="taskStyle"
                class="d-flex justify-content-between w-100 px-2 dayplanner-item-sequence-task__block">
                <div>{{ task.title }}</div>
                <div>{{ task.duration | hoursMinutes }}</div>
              </div>
              <!--<div style="display: flex;" v-if="!sequenceItemIdAdded(task.sequenceItemId)">
                <el-button
                size="mini"
                @click="onAddSequenceItem(task.sequenceItemId)"
                style="float: right; width: 50px; height: 25px"
                :disabled="sequenceItemIdAdded(task.sequenceItemId)">
                Add
              </el-button>
              </div>-->
            </div>
          </div>
        </div>
      </div>
      <pre v-if="SHOW_DEBUG" class="mini-pre">
  view_selected_date_as_yymmdd: {{ view_selected_date_as_yymmdd }}
  optimizer_result_data: {{ suggestion }}
      </pre>
    </el-card>

    <div
      class="dayplanner-suggestion-caret"
      @mouseover="onMouseoverAddItem('TASKLIST', itemPlacementConfig)"
      @mouseleave="onMouseleaveAddItem">
      <el-button
        size="mini"
        @click="onAddItem({ type: 'TASKLIST', sequenceItems: sequenceTasks })">
        <font-awesome-icon :icon="['fas', 'chevron-right']" size="lg" /><br />
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SuggestionItemMixin from './SuggestionItemMixin.js'

// TODO: Compare to ItemTasklist and check if it is still up to date

//const log1 = (...args) => { console.log(...args) }

export default {
  mixins: [ SuggestionItemMixin ],
  props: {
   // See mixin
  },
  data: () => ({
    checked: true,
  }),
  computed: {
    ...mapGetters("optimizer", ["optimizer_result_data"]),

    /* --- MIXIN --- */
    /*
    ...mapGetters("dayplanner", [
      "dayplan_from_db_at_selected_day",
      "view_selected_date_as_yymmdd",
      "view_selected_date_as_timestamp",
    ]),

    goalId() {
      return this.config.goalId;
    },
    commitmentId() {
      return this.config.commitmentId;
    },
    goal_meta() {
      return this.$models.goalMeta.getNode( this.goalId );
    },
    commitment() {
      return this.$models.commitment.with({ goalId: this.goalId }).subscribeNode(this.commitmentId);
    },*/
    sessionPlacementDuration() {
      let sessionPlacementDuration = 0;
      if (this.suggestion && this.suggestion.tasks) {
        this.suggestion.tasks.forEach(task => {
          sessionPlacementDuration += task.duration;
        });
      }
      return sessionPlacementDuration;
    },
    itemPlacementConfig() {
      return {
        duration: this.sessionPlacementDuration,
        placeAtEnd: false
      }
    },
    sessionItems() {
      if (this.optimizer_result_data["sessionItems"]) {
        return this.optimizer_result_data["sessionItems"];
      } else {
        return [];
      }
    },

    suggestion() {
      /*console.log('this.optimizer_result_data', this.optimizer_result_data)
      if (this.optimizer_result_data["dayplan_suggestions"] && this.optimizer_result_data["dayplan_suggestions"][this.view_selected_date_as_yymmdd] && this.optimizer_result_data["dayplan_suggestions"][this.view_selected_date_as_yymmdd]) {
        log1('suggestion', this.view_selected_date_as_yymmdd, this.optimizer_result_data["dayplan_suggestions"], this.optimizer_result_data["dayplan_suggestions"][this.view_selected_date_as_yymmdd], this.optimizer_result_data["dayplan_suggestions"][this.view_selected_date_as_yymmdd][this.config.commitmentId])
      } else {
        log1('suggestion - nothing found')
      }*/
      if (
        this.optimizer_result_data["dayplan_suggestions"] &&
        this.optimizer_result_data["dayplan_suggestions"][this.view_selected_date_as_yymmdd] &&
        this.optimizer_result_data["dayplan_suggestions"][this.view_selected_date_as_yymmdd][this.config.commitmentId]
      ) {
        return this.optimizer_result_data["dayplan_suggestions"][this.view_selected_date_as_yymmdd][this.config.commitmentId];
      } else {
        return null;
      }
    },
    sequenceTasks() {
      let tasks = null
      if (this.suggestion.tasks) {
        tasks = []
        this.suggestion.tasks.forEach(taskData => {
          let task = {
            taskId: 'test', //taskData.$id,
            from: 1234567890, // TODO: change
            duration: taskData.duration,
            cachedTitle: taskData.title + ' - day ' + this.suggestion.day,
            cachedFinishedAt: null,
        };
        tasks.push(task)
        })
      }
      //console.log('sequenceTasks', tasks)
      return tasks
    },

    taskStyle() {
      return {
        "background-color": this.tscColor,
      };
    },
    dayplan_filtered() {
      if (this.dayplan_from_db_at_selected_day) {
        return this.dayplan_from_db_at_selected_day.filter(item => item.config.commitmentId === this.commitmentId)
      }
      return null
    }
  },
  methods: {
    onGoToCommitment() {
      this.$router.push("/goal/" + this.goalId + "/kanban");
    },

    sequenceItemIdAdded(sequenceItemId) {
      //return false; // TODO Check if item was already added
      //console.log('sequenceItemIdAdded', sequenceItemId, this.dayplan_filtered)
      if (this.dayplan_filtered) {
        for (let i = 0; i < this.dayplan_filtered.length; i++) {
          for (let u = 0; u < this.dayplan_filtered[i].sequenceItems.length; u++) {
            if (sequenceItemId === this.dayplan_filtered[i].sequenceItems[u].sequenceItemId) {
              return true
            }
          }
        }
      }
      return false
    }
  },
};
</script>

<style>
.item-sequence {
  margin-top: 0.5em;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: stretch;
}

.dayplanner-item-sequence-task {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 0.2em;
}

.dayplanner-item-sequence-task__block {
  background-color: #999;
  color: #FFFFFF;
  font-weight: bold;
  border-radius: 3px;
  min-height: 25px;
  font-size: 10pt;
  align-items: center;
}
</style>
